// extracted by mini-css-extract-plugin
export var container = "RequestConsultation-module--container--e227c";
export var title = "RequestConsultation-module--title--a3b34";
export var formWrap = "RequestConsultation-module--formWrap--45ed3";
export var mobileHidden = "RequestConsultation-module--mobileHidden--ce771";
export var desktopHidden = "RequestConsultation-module--desktopHidden--405df";
export var loaderWrap = "RequestConsultation-module--loaderWrap--39e58";